import { config } from '@uhg-abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import SEND_EMAIL_TEXT_ONLY from './SendEmail.graphql';

export const useSendEmail = (options) =>
  useCustomQuery(SEND_EMAIL_TEXT_ONLY, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'sendEmail',
  });
